module.exports = __webpack_public_path__ + "img/3486c08096e541acaa0dee0c14bdd4cf-640.c238770d.jpg";